import { render } from "./DevicesList.vue?vue&type=template&id=660a7552"
import script from "./DevicesList.vue?vue&type=script&lang=js"
export * from "./DevicesList.vue?vue&type=script&lang=js"

import "./DevicesList.vue?vue&type=style&index=0&id=660a7552&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__